import { Component } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import { WidgetsModal } from '../widget-library/WidgetsModal'
import Portal from 'preact-portal'
import AddWidgetButton from './AddWidgetButton'
import { FULL_WIDTH_CONTAINER, WidgetContainerType } from '@insided/customization'

export type WidgetChoiceHandler = (type: string) => void

interface Props {
  onToggle: (isVisible: boolean) => void
  onWidgetChoice: WidgetChoiceHandler
  x: number
  y: number
  width?: number
  nested: boolean
  visible: boolean
  setListeningToMouse: (listen: boolean, callback: () => void) => void
  containerComponent: WidgetContainerType
}

interface State {
  displayWidgetModal: boolean
  height: number | null
  width: number | null
}

const calculateMaxWidth = (value: number | undefined): number | 'auto' => {
  if (value === undefined) {
    return 'auto'
  }
  if (value === 0) {
    /**
     * When the container-2-1 widget is used
     * the script can't calculate width of an empty slot (it's a bug)
     * and then the 2px line (`.add-widget-button-line`) is overflowing the sub-container
     * so if it's 0 we hide the line
     */
    return 0
  }
  return value
}

const calculateLeft = (x: number, nested: boolean) => {
  if (x < 63 && nested) {
    // so that the button is not hidden behind the viewport
    return 63
  }
  return x
}

export default class NewButton extends Component<Props, State> {
  ref: HTMLElement | null = null
  state = {
    width: null,
    height: null,
    displayWidgetModal: false
  }

  render() {
    const {
      onWidgetChoice,
      visible,
      nested,
      x,
      y,
      setListeningToMouse,
      containerComponent = FULL_WIDTH_CONTAINER
    } = this.props
    const { displayWidgetModal } = this.state

    return (
      <div
        className='add-widget-button-wrapper'
        ref={(el) => {
          if (this.state.width === null) {
            this.setState({ width: 0, height: 0 })
          }
          this.ref = el
        }}
        style={{
          top: y,
          left: calculateLeft(x, nested),
          maxWidth: calculateMaxWidth(this.props.width),
          boxShadow: 'inset 0 0 5px rgba(255,0,0,.2), 0 0 5px rgba(0,255,0,0.2)'
        }}
      >
        <AddWidgetButton
          visible={visible}
          nested={nested}
          onClick={() => {
            setListeningToMouse(false, () => {
              this.setState({ displayWidgetModal: true })
            })
          }}
        />

        <div>
          {displayWidgetModal && (
            <Portal into='body'>
              <WidgetsModal
                onClose={() => {
                  setListeningToMouse(true, () => this.setState({ displayWidgetModal: false }))
                }}
                onWidgetSelected={(type) => onWidgetChoice(type)}
                containerComponent={containerComponent}
              />
            </Portal>
          )}
        </div>
      </div>
    )
  }
}
